import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveShortLink } from "@/lib/public-helpers.functions";

type ShortSearch = { ref?: string | undefined };

/**
 * Short links: behot.now/ab3k9x -> /p/<listing-slug>.
 * Redirects (301-style) so crawlers resolve the full listing metadata,
 * while keeping any ?ref= referral code attached.
 */
export const Route = createFileRoute("/$code")({
  validateSearch: (search: Record<string, unknown>): ShortSearch =>
    typeof search["ref"] === "string" ? { ref: search["ref"] } : {},
  beforeLoad: async ({ params, search }) => {
    const code = params.code.toLowerCase();
    if (!/^[a-z0-9]{4,8}$/.test(code)) throw redirect({ to: "/" });

    const { path } = await resolveShortLink({ data: { code } });
    if (!path) throw redirect({ to: "/" });

    const target = search.ref
      ? `${path}${path.includes("?") ? "&" : "?"}ref=${encodeURIComponent(search.ref)}`
      : path;

    throw redirect({ href: target });
  },
});
